import { render, staticRenderFns } from "./BlackGoldPointConvertModal.vue?vue&type=template&id=51859fd6&"
import script from "./BlackGoldPointConvertModal.vue?vue&type=script&lang=js&"
export * from "./BlackGoldPointConvertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports